<template>
  <div>
    <div v-if="propConfig.length > 0">
      <el-form
        :size="$xUISize"
        ref="formInputRef"
        :model="inputModel"
        :rules="inputRules"
        label-width="auto"
        label-position="top"
      >
        <div
          :key="'form-' + item.name + '-' + i"
          :style="i > 0 ? 'margin-top: 25px' : ''"
          v-show="checkShow(item)"
          v-for="(item, i) in propConfig"
        >
          <el-form-item
            :label="`${[item.label, showName && item.label != item.name ? item.name : '']
              .filter((item) => !!item)
              .join(' - ')}`"
            :prop="item.name"
          >
            <div>
              <el-input-number
                v-if="item.type == 'number'"
                controls-position="right"
                style="width: 100%; text-align: left"
                :disabled="item.disabled"
                :precision="item.numPrecision"
                :step="item.numStep"
                :min="item.numMin"
                :max="item.numMax"
                :placeholder="item.desc || '请输入' + (item.label || item.name)"
                @change="handleInputConfirm(item)"
                v-model.number="inputModel[item.name]"
              >
              </el-input-number>
              <el-input
                v-else-if="item.type == 'color'"
                type="text"
                :placeholder="item.desc || '请输入' + (item.label || item.name)"
                :disabled="item.disabled"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
              >
                <el-color-picker
                  slot="append"
                  size="mini"
                  @change="handleInputConfirm(item)"
                  v-model="inputModel[item.name]"
                >
                </el-color-picker>
              </el-input>
              <template v-else-if="item.type == 'json'">
                <div>
                  <json-editor
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                    :disabled="item.disabled"
                    :placeholder="item.desc || '请输入' + (item.label || item.name)"
                  />
                </div>
              </template>
              <template v-else-if="item.type == 'markdown'">
                <div>
                  <md-editor
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                    :disabled="item.disabled"
                    :placeholder="item.desc || '请输入' + (item.label || item.name)"
                  />
                </div>
              </template>
              <template v-else-if="item.type == 'html'">
                <div>
                  <x-input
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                    :disabled="item.disabled"
                    :options="{
                      label: item.desc || '请输入' + (item.label || item.name),
                      type: 'html',
                    }"
                  ></x-input>
                </div>
              </template>
              <template v-else-if="item.type == 'fileBase64'">
                <div>
                  <file-base-64
                    :placeholder="item.desc || '请选择' + (item.label || item.name)"
                    :rows="item.rows || 5"
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                  />
                </div>
              </template>
              <template v-else-if="item.type == 'file'">
                <div>
                  <x-upload
                    type="file"
                    imageAlign="start"
                    :fileSize="item.fileSize || 5 * 1024"
                    :fileCount="item.fileCount || 1"
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                  ></x-upload>
                </div>
              </template>
              <template v-else-if="item.type == 'image'">
                <div>
                  <x-upload
                    type="image"
                    imageAlign="start"
                    :fileSize="item.fileSize || 5 * 1024"
                    :fileCount="item.fileCount || 1"
                    v-model="inputModel[item.name]"
                    @change="handleInputConfirm(item)"
                  ></x-upload>
                </div>
              </template>
              <el-date-picker
                type="datetime"
                v-else-if="item.type == 'timestamp'"
                :placeholder="item.desc || '请选择' + (item.label || item.name)"
                format="yyyy-MM-dd hh:mm"
                value-format="timestamp"
                :disabled="item.disabled"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                style="width: 100%"
              ></el-date-picker>
              <el-date-picker
                type="date"
                v-else-if="item.type == 'date'"
                :placeholder="item.desc || '请选择' + (item.label || item.name)"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :disabled="item.disabled"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                style="width: 100%"
              ></el-date-picker>
              <el-select
                v-else-if="item.type == 'checkbox'"
                multiple
                :clearable="item.clearable"
                :disabled="item.disabled"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                :placeholder="item.desc || '请选择' + (item.label || item.name)"
                style="width: 100%"
              >
                <el-option
                  v-for="item in parseSelectOtions(item.options)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-else-if="item.type == 'select'"
                :clearable="item.clearable"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                :disabled="item.disabled"
                :placeholder="item.desc || '请选择' + (item.label || item.name)"
                style="width: 100%"
              >
                <el-option
                  v-for="item in parseSelectOtions(item.options)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-else-if="item.type == 'textarea'"
                type="textarea"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                :disabled="item.disabled"
                :rows="item.rows || 2"
                :maxlength="item.lenMax || 1024 * 1024"
                :placeholder="item.desc || '请输入' + (item.label || item.name)"
              >
              </el-input>
              <el-checkbox
                v-else-if="item.type == 'boolean'"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                :disabled="item.disabled"
                false-label="false"
                true-label="true"
              >
                {{ item.desc }}
              </el-checkbox>
              <el-input
                v-else
                :rows="1"
                type="textarea"
                :maxlength="item.lenMax || 1024"
                :placeholder="item.desc || '请输入' + (item.label || item.name)"
                @change="handleInputConfirm(item)"
                v-model="inputModel[item.name]"
                :disabled="item.disabled"
              >
              </el-input>
            </div>
            <span v-if="item.tips" style="color: #999">
              {{ item.tips }}
            </span>
          </el-form-item>
        </div>
        <el-form-item v-if="showSlot">
          <slot></slot>
        </el-form-item>
      </el-form>
    </div>
    <div v-else-if="emptyLabel">
      <van-empty :description="emptyLabel" :image="emptyIcon" />
    </div>
  </div>
</template>

<style lang="less" scoped>
/deep/ .el-input-number .el-input__inner {
  text-align: left;
}

/deep/ .el-color-picker__trigger {
  padding: 0px;
  border: 0px solid #e6e6e6;
  margin-top: 2px;
}

/deep/ .el-color-picker--mini .el-color-picker__trigger {
  height: 18px;
  width: 40px;
}

/deep/ .el-color-picker--mini {
  height: 18px;
}
</style>

<script>
import MdEditor from "./mdEditor.vue";
import JsonEditor from "./jsonEditor.vue";
import UploadFile from "./uploadFile.vue";
import FileBase64 from "./fileBase64.vue";

export default {
  components: {
    MdEditor,
    JsonEditor,
    UploadFile,
    FileBase64,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String | Number | Object,
      required: true,
      default: "",
    },
    config: {
      type: String | Object,
      required: true,
      default: "",
    },
    showName: {
      type: Boolean,
      default: false,
    },
    showSlot: {
      type: Boolean,
      default: false,
    },
    emptyLabel: {
      type: String,
    },
    emptyIcon: {
      type: String,
    },
    format: {
      type: "string" | "object",
      default: "string",
    },
  },
  watch: {
    config() {
      this.initConfig();
    },
    value() {
      this.initValue();
    },
  },
  mounted() {
    this.initConfig();
    this.initValue();
  },
  data() {
    return {
      propConfig: [],
      inputModel: {},
      inputRules: {},
    };
  },
  computed: {
    defaultValue() {
      let newModel = {};
      this.propConfig
        .map((item) => {
          return {
            type: item.type,
            name: item.name,
            default: item.defaultValue,
          };
        })
        .forEach((item) => {
          if (item.default) {
            let defaultVal = item.default;
            if (item.type == "boolean") {
              defaultVal = defaultVal == 1 || defaultVal == "true";
            } else if (item.type == "number") {
              defaultVal = Number(defaultVal) || 0;
            }
            newModel[item.name] = defaultVal;
          }
        });
      return newModel;
    },
  },
  methods: {
    initValue() {
      if (this.value) {
        try {
          let model = this.toAny(this.value, {});
          let isArray = model instanceof Array;
          if (isArray) {
            this.inputModel = Object.assign({}, this.defaultValue);
          } else {
            this.inputModel = Object.assign({}, this.defaultValue, model);
          }
        } catch (error) {}
      } else {
        this.inputModel = Object.assign({}, this.defaultValue);
      }
    },
    initConfig() {
      if (this.config) {
        try {
          let configObj = this.toAny(this.config, {});
          let isArray = configObj instanceof Array;
          if (!isArray) {
            this.propConfig = [];
          } else {
            this.propConfig = [...configObj];
          }
          this.inputRules = {};
          this.propConfig.forEach((item) => {
            if (item.required) {
              this.inputRules[item.name] = {
                required: true,
                message: `缺少必填项【${item.label}】`,
                trigger: "change",
              };
            }
          });
          this.propConfig.sort(function (a, b) {
            return (b.required ? 1 : 0) - (a.required ? 1 : 0);
          });
        } catch (error) {}
      } else {
        this.propConfig = [];
      }
    },
    checkShow(data) {
      if (data.show && typeof data.show === "function") {
        return data.show(this.inputModel);
      }
      return true;
    },
    parseSelectOtions(data) {
      let list = [];
      `${data}`.split("\n").forEach((item) => {
        let itemList = item.split("|");
        if (itemList.length >= 2) {
          list.push({
            label: itemList[0],
            value: itemList[1],
          });
        }
      });
      return list;
    },
    filterInputModel() {
      let newModel = {};
      this.propConfig.forEach((item) => {
        let val = this.inputModel[item.name];
        if (item.type == "boolean") {
          val = this.toAny(val, false);
        } else if (item.type == "number") {
          val = this.toAny(val, 0);
        }
        newModel[item.name] = val;
      });
      return newModel;
    },
    handleInputConfirm(item) {
      this.validate(() => {
        if (this.format == "string") {
          this.$emit("change", JSON.stringify(this.filterInputModel()));
        } else {
          this.$emit("change", this.filterInputModel());
        }
      });
    },
    validate(callback) {
      if (this.$refs.formInputRef) {
        this.$refs.formInputRef.validate(callback);
      } else {
        callback && callback(true);
      }
    },
  },
};
</script>
